import React from 'react';

import '../../styles/_panes.less';

/**
 * Composants globaux pour les panneaux du site
 * @module
 */


/** Panneau vertical */
export const Pane = ({title, style = {}, children, className = ''}) => {
  return (
    <div className={`pane ${className}`} style={style}>
      <h1>{title}</h1>
      {children}
    </div>
  )
};


/** Bloc dans un panneau */
export const Part = ({title, children, className = ''}) => {
  return (
    <div className={`part ${className}`}>
      <h2>{ title }</h2>
      {children}
      <div style={{clear: 'both'}}></div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/commons/Panes.js